module.exports = __webpack_public_path__ + "logo.06868ce0.png";